import React from 'react'
import PropTypes from 'prop-types'

import { utils } from 'parking-react-common'

import { sum, map, groupBy } from 'lodash'

const ListTotals = ({ field, unitField, data }) => {
    const byUnit = groupBy(data, unitField)
    return (
        <>
            { map(byUnit, (values, currency) => (
                <div key={ currency }>
                    { utils.formatAmountWithUnit(sum(map(values, field)), currency) }
                </div>
            )) }
        </>
    )
}

ListTotals.propTypes = {
    field     : PropTypes.string,
    unitField : PropTypes.string,
    data      : PropTypes.arrayOf(PropTypes.object)
}

export default ListTotals
